import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell11InchPortrait from 'public/images/tablet-shells/FireTabletsFeatureRotator__11Inch_Portrait_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
} from '../constants';

export const TABLET_11INCH_PORTRAIT_FOS: PreviewStateConfig = {
  label: '11" Portrait',
  altText: ALT_TEXT,
  dimensions: { width: 1200, height: 2000 },
  metadataZone: { top: 350, ctaTop: 742, safeZone: 70, leftMargin: 93 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 13,
        y: 321,
        width: 1174,
        height: 524,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 13, y: 321, width: 587, height: 524 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 443,
        maxHeight: 180,
        position: { x: 93, y: 430 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 93,
        y: 676,
      },
      fontSize: 23,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 450,
      maxLines: MAX_LINES,
      lineHeight: 30,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 13, y: 321, width: 1174, height: 29 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 13, y: 801, width: 1174, height: 44 },
    },
    { type: LayerType.SHELL, src: shell11InchPortrait },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
